import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { ClarityModule } from '@clr/angular';
import { VcaCommonModule } from '../../../common';
import { Ng2DatetimePickerModule } from 'ng2-datetime-picker';

import { JobTypePipe, WorkflowTypePipe, JobStatusPipe, JobDescriptionPipe, UserNamePipe } from './custom-pipes.pipe';
import ActivityLog from './activity-log.component';

@NgModule({
    declarations: [
        JobTypePipe,
        WorkflowTypePipe,
        JobStatusPipe,
        JobDescriptionPipe,
        UserNamePipe,
        ActivityLog
    ],
    imports: [
        BrowserModule,
        FormsModule,
        VcaCommonModule,
        TranslateModule,
        ClarityModule,
        Ng2DatetimePickerModule
    ],
    providers: [
    ],
    exports: [
        JobTypePipe,
        WorkflowTypePipe,
        JobStatusPipe,
        JobDescriptionPipe,
        UserNamePipe,
        ActivityLog
    ]
})
export class ActivityLogModule {
    constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/components/activity-log/activity-log.module.ts